module.exports = __webpack_public_path__ + "static/media/landing_course4.e62f541a.jpg";